/* One set of the store's existing area rules, shared by every delivery checker. */
(() => {
  const validAreas = new Set('AB AL B BA BB BD BH BL BN BR BS BT CA CB CF CH CM CO CR CT CV CW DA DD DE DG DH DL DN DT DY E EC EH EN EX FK FY G GL GU HA HD HG HP HR HS HU HX IG IP IV KA KT KW KY L LA LD LE LL LN LS LU M ME MK ML N NE NG NN NP NR NW OL OX PA PE PH PL PO PR RG RH RM S SA SE SG SK SL SM SN SO SP SR SS ST SW SY TA TD TF TN TQ TR TS TW UB W WA WC WD WF WN WR WS WV YO ZE'.split(' '));
  const unavailable = new Set(['HS', 'KW', 'ZE']);
  const surcharges = { AB: 149, BT: 149, CT: 99, DD: 99, EX: 99, IV: 149, PH: 99, PL: 99, TA: 99, TQ: 99, TR: 99 };

  function resolvePostcode(value) {
    const compact = value.trim().toUpperCase().replace(/\s+/g, '');
    const match = compact.match(/^([A-Z]{1,2}\d[A-Z\d]?)(\d[A-Z]{2})?$/);
    if (!match) return { kind: 'invalid' };
    const outward = match[1];
    const district = outward.match(/^([A-Z]{1,2})(\d{1,2})[A-Z]?$/);
    if (!district || !validAreas.has(district[1])) return { kind: 'invalid' };
    const area = district[1];
    const number = Number(district[2]);
    const postcode = outward + (match[2] ? ` ${match[2]}` : '');
    if (unavailable.has(area) || (area === 'PA' && number >= 20) || (area === 'PO' && number >= 23) || (area === 'PH' && number > 26)) {
      return { kind: 'unavailable', postcode };
    }
    const surcharge = area === 'PH' && number >= 22 ? 149 : (surcharges[area] || 0);
    return { kind: 'available', postcode, surcharge, estimate: surcharge ? '7–14 working days' : '2–7 working days' };
  }

  function initCheckers(scope = document) {
    scope.querySelectorAll('[data-lmb-postcode]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const form = root.querySelector('form');
      const input = form.querySelector('input');
      const result = root.querySelector('[role="status"]');
      const line = (tag, text, className) => {
        const el = document.createElement(tag);
        el.textContent = text;
        if (className) el.className = className;
        result.appendChild(el);
      };
      input.addEventListener('input', () => {
        input.removeAttribute('aria-invalid');
        result.hidden = true;
      });
      form.addEventListener('submit', event => {
        event.preventDefault();
        const checked = resolvePostcode(input.value);
        result.replaceChildren();
        result.hidden = false;
        result.className = `lmb-product-postcode__result is-${checked.kind}`;
        input.setAttribute('aria-invalid', String(checked.kind === 'invalid'));
        if (checked.kind === 'invalid') {
          line('strong', 'Let’s check that postcode');
          line('p', 'Enter a full UK postcode or a district, such as SW17.');
          input.focus();
          return;
        }
        input.value = checked.postcode;
        if (checked.kind === 'unavailable') {
          line('strong', `Delivery is not currently available to ${checked.postcode}`);
          line('p', 'Our team can help you check an alternative delivery address.');
          const link = document.createElement('a');
          link.href = '/pages/contact';
          link.textContent = 'Ask our team →';
          result.appendChild(link);
          return;
        }
        line('strong', `We deliver to ${checked.postcode}`);
        line('p', checked.surcharge ? `£${checked.surcharge} regional delivery surcharge` : '£0 regional delivery surcharge', 'lmb-product-postcode__charge');
        const estimate = root.dataset.preorder || `In-stock items: approximately ${checked.estimate}.`;
        line('p', estimate, 'lmb-product-postcode__estimate');
        line('small', root.dataset.preorder ? 'We’ll confirm your delivery day when your pre-order is ready.' : 'Made-to-order and pre-order items follow their own product lead times.');
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initCheckers());
  else initCheckers();
  document.addEventListener('shopify:section:load', event => initCheckers(event.target));
})();
